import React from 'react'
import { Link } from '@tanstack/react-router'
import { withPageProtection } from '@/lib/rbac/hoc'
import { PAGES } from '@/lib/rbac/constants'
import { Button } from '@/components/ui/Button'
import { RoleForm } from '@/components/workforce/RoleForm'
import { ArrowLeft, Briefcase } from 'lucide-react'

function NewRoleContent() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Link to="/workforce/roles">
          <Button variant="ghost" size="sm">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar
          </Button>
        </Link>
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-white flex items-center gap-3">
            <Briefcase className="w-8 h-8 text-brand-primary" />
            Novo Cargo
          </h1>
          <p className="font-body text-brand-gray mt-2">
            Crie um novo cargo com responsabilidades e requisitos
          </p>
        </div>
      </div>

      {/* Form */}
      <RoleForm mode="create" />
    </div>
  )
}

// Apply RBAC protection
export default withPageProtection(NewRoleContent, PAGES.WORKFORCE_ROLES)
